import { render } from "./DsgvoComponent.vue?vue&type=template&id=58ad4ae6&ts=true"
import script from "./DsgvoComponent.vue?vue&type=script&lang=ts"
export * from "./DsgvoComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__